// Lives in its own file (not inline in usersFeature.ts) so route factories and
// screens can import these constants without a circular import back through
// usersFeature.ts -> presentation/routes -> here.
const USER_MANAGEMENT_LIST = "core.user_management.user_management_list";
const DRIVER_MANAGEMENT_LIST = "core.user_management.driver_management_list";

export const USER_MANAGEMENT_VIEW = `${USER_MANAGEMENT_LIST}.view`;
export const USER_MANAGEMENT_CREATE = `${USER_MANAGEMENT_LIST}.create`;
export const USER_MANAGEMENT_UPDATE = `${USER_MANAGEMENT_LIST}.update`;
export const USER_MANAGEMENT_DELETE = `${USER_MANAGEMENT_LIST}.delete`;

export const DRIVERS_VIEW = `${DRIVER_MANAGEMENT_LIST}.view`;
export const DRIVERS_CREATE = `${DRIVER_MANAGEMENT_LIST}.create`;
export const DRIVERS_UPDATE = `${DRIVER_MANAGEMENT_LIST}.update`;
export const DRIVERS_DELETE = `${DRIVER_MANAGEMENT_LIST}.delete`;
